import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const images = [
    {
      url: 'https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/5e7f2eeb129b4a253375a206a6fbd6cf.jpeg',
      title: 'Elegant Weddings'
    },
    {
      url: 'https://public.readdy.ai/ai/img_res/f49f950506a1f956dc8c16b3c4c31eed.jpg',
      title: 'Corporate Events'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=birthday%20celebration%20party%20with%20elegant%20decoration%20professional%20waiters%20serving%20champagne%20colorful%20balloons%20festive%20atmosphere%20luxury%20catering%20service%20happy%20guests&width=1000&height=800&seq=gallery-birthday-003&orientation=landscape',
      title: 'Special Birthdays'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=family%20gathering%20dinner%20with%20professional%20catering%20service%20elegant%20table%20setting%20warm%20atmosphere%20waiters%20serving%20food%20intimate%20celebration%20home%20style%20elegance&width=1000&height=800&seq=gallery-family-004&orientation=landscape',
      title: 'Family Gatherings'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=gala%20dinner%20event%20with%20professional%20waiters%20in%20formal%20attire%20serving%20guests%20luxurious%20venue%20with%20elegant%20lighting%20fine%20dining%20experience%20premium%20catering%20service&width=800&height=1000&seq=gallery-gala-005&orientation=portrait',
      title: 'Gala Dinners'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=outdoor%20garden%20party%20with%20elegant%20catering%20setup%20professional%20staff%20serving%20guests%20beautiful%20natural%20setting%20with%20flowers%20and%20greenery%20sophisticated%20outdoor%20dining&width=800&height=1000&seq=gallery-outdoor-006&orientation=portrait',
      title: 'Outdoor Events'
    }
  ];

  const openModal = (index: number) => {
    setSelectedImage(index);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'unset';
  };

  const nextImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage + 1) % images.length);
    }
  };

  const prevImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage - 1 + images.length) % images.length);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowRight') nextImage();
    if (e.key === 'ArrowLeft') prevImage();
  };

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-6 py-2 bg-[#D4AF37]/10 rounded-full border border-[#D4AF37]/20">
            <span className="text-[#D4AF37] text-sm font-semibold tracking-wide">GALLERY</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-gray-900 font-bold mb-6">
            Our Work
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Every event is unique and special. Take a look at some of our most outstanding work
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div 
              key={index}
              onClick={() => openModal(index)}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
              style={{ height: index === 2 || index === 3 ? '400px' : '500px' }}
            >
              <img 
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-white text-2xl font-bold">{image.title}</h3>
                  <p className="text-white/80 text-sm mt-2">Click to view more</p>
                </div>
              </div>
              <div className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line text-[#D4AF37] text-xl"></i>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal de álbum */}
      {selectedImage !== null && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center"
          onClick={closeModal}
          onKeyDown={handleKeyDown}
          tabIndex={0}
        >
          {/* Botón cerrar */}
          <button
            onClick={closeModal}
            className="absolute top-6 right-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all cursor-pointer z-10"
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>

          {/* Contador */}
          <div className="absolute top-6 left-6 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full z-10">
            <span className="text-white font-semibold">
              {selectedImage + 1} / {images.length}
            </span>
          </div>

          {/* Botón anterior */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            className="absolute left-6 w-14 h-14 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all cursor-pointer z-10"
          >
            <i className="ri-arrow-left-s-line text-white text-3xl"></i>
          </button>

          {/* Botón siguiente */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            className="absolute right-6 w-14 h-14 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all cursor-pointer z-10"
          >
            <i className="ri-arrow-right-s-line text-white text-3xl"></i>
          </button>

          {/* Imagen principal */}
          <div 
            className="max-w-6xl max-h-[85vh] mx-auto px-20"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={images[selectedImage].url}
              alt={images[selectedImage].title}
              className="w-full h-full object-contain rounded-lg"
            />
            <div className="text-center mt-6">
              <h3 className="text-white text-3xl font-bold mb-2">
                {images[selectedImage].title}
              </h3>
            </div>
          </div>

          {/* Miniaturas */}
          <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-3 bg-white/10 backdrop-blur-sm p-4 rounded-2xl max-w-4xl overflow-x-auto">
            {images.map((image, index) => (
              <div
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImage(index);
                }}
                className={`w-20 h-20 rounded-lg overflow-hidden cursor-pointer transition-all flex-shrink-0 ${
                  selectedImage === index 
                    ? 'ring-4 ring-[#D4AF37] scale-110' 
                    : 'opacity-60 hover:opacity-100'
                }`}
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
